import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

const AdminCard = ({ 
  title, 
  subtitle, 
  icon: Icon, 
  children, 
  elevation = 2,
  sx = {},
  headerSx = {},
  contentSx = {}
}) => {
  const theme = useTheme();

  return (
    <Card 
      elevation={elevation}
      sx={{
        borderRadius: 2.5, // ~12px
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
          transform: 'scale(1.02)'
        },
        ...sx
      }}
    >
      {(title || Icon) && (
        <CardHeader
          avatar={Icon && (
            <Box
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                borderRadius: 2,
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Icon 
                sx={{ 
                  color: theme.palette.primary.main,
                  fontSize: 24
                }} 
              />
            </Box>
          )}
          title={title}
          subheader={subtitle}
          titleTypographyProps={{
            variant: 'h6',
            fontWeight: 600,
            color: theme.palette.text.primary
          }}
          subheaderTypographyProps={{
            variant: 'body2',
            color: theme.palette.text.secondary
          }}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.02),
            borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
            ...headerSx
          }}
        />
      )}
      <CardContent 
        sx={{
          p: 3,
          '&:last-child': {
            pb: 3
          },
          ...contentSx
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default AdminCard;
